export default __webpack_public_path__ + "media/images/clients-03-150x134-52c3464d8a5c4fa7a2860a097d70c645.png";